export default __webpack_public_path__ + "static/media/top_b.d37dad65.jpg";